import { QuickActionMetadata } from '../../../chat.types';
import { MessageHandler, MessageVariant } from '../../ChatUserMessage.types';

export const quickActionMessageHandler: MessageHandler<QuickActionMetadata> = {
  submit: (args, metadata) => ({
    role: 'user' as const,
    content: args.text || '',
    parts: [{ type: 'text' as const, text: args.text }],
    metadata: metadata,
    annotations: [{ type: MessageVariant.QUICK_ACTION }],
  }),
};
